import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import { CommonModule, formatDate, Location } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  FullCalendarComponent,
  FullCalendarModule,
} from '@fullcalendar/angular';
import kaLocale from '@fullcalendar/core/locales/ka';
import {
  BookingService,
  EmployeeService,
  ScheduleService,
  transformDateTime,
  User,
  UserService,
} from '@beautyapp/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { AddAppointmentComponent } from '../../booking-modal/components/add-appointment/add-appointment.component';
import { Store } from '@ngxs/store';
import { AuthState } from '@beautyapp/auth';
import momentPlugin, { toMoment } from '@fullcalendar/moment';
import {
  CalendarTimeInterval,
  ClearAddAppointmentSpecService,
  ClearAddEmployeeAppointment,
} from '../../appointment.actions';
import {
  AppointmentState,
  computeCalendarBookingAmounts,
} from '../../appointment.state';
import momentTimezonePlugin from '@fullcalendar/moment-timezone';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { ActivatedRoute } from '@angular/router';
import {
  CalendarOptions,
  EventClickArg,
  EventHoveringArg,
  EventInput,
} from '@fullcalendar/core';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import { addDays, format } from 'date-fns';
import { VisitManageComponent } from '../../visit-modal/visit-manage.component';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzSpaceModule, NzSpaceCompactComponent } from 'ng-zorro-antd/space';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { DatepickerComponent } from '@beautyapp/form';

@Component({
  selector: 'beautyapp-day-grid',
  templateUrl: './day-grid-employee.component.html',
  styleUrls: ['./day-grid-employee.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    FullCalendarModule,
    NzLayoutModule,
    NzGridModule,
    NzSpaceModule,
    NzSpaceCompactComponent,
    NzButtonModule,
    NzIconModule,
    NzTypographyModule,
    NzPopoverModule,
    NzTooltipDirective,
    DatepickerComponent,
  ],
})
export class DayGridEmployeeComponent implements OnInit {
  private employeeService = inject(EmployeeService);
  private userService = inject(UserService);
  private bookingService = inject(BookingService);
  private modalService = inject(NzModalService);
  private drawerService = inject(NzDrawerService);
  private store = inject(Store);
  private spinner = inject(NgxSpinnerService);
  private _location = inject(Location);
  private _cd = inject(ChangeDetectorRef);
  private route = inject(ActivatedRoute);
  private translateService = inject(TranslateService);
  private scheduleService = inject(ScheduleService);

  @ViewChild('popoverElementRef', { read: ElementRef })
  popoverElementRef!: ElementRef;
  fromRoute = false;
  employeeId: any;
  user: User = {} as User;
  userId: any;
  currentDate?: string;
  startTime!: Date;
  events: any;
  eventsModel: any;
  // beaut-365: day-form slot granularity, shared/persisted via AppointmentState.
  timeInterval?: string = '00:15:00';
  @ViewChild('calendar') calendarComponent!: FullCalendarComponent;
  calendarOptions: CalendarOptions = {
    initialView: 'timeGrid',
    views: {
      timeGridSevenDays: {
        type: 'timeGrid',
        duration: { days: 7 },
      },
    },
    locales: [kaLocale],
    locale: 'ka',
    timeZone: 'Asia/Tbilisi',
    plugins: [
      timeGridPlugin,
      interactionPlugin,
      resourceTimelinePlugin,
      momentPlugin,
      momentTimezonePlugin,
    ],
    editable: false,
    selectable: true,
    nowIndicator: true,
    height: '100%',
    eventClick: this.handleEventClick.bind(this),
    dateClick: this.handleDateClick.bind(this),
    select: this.handleDateSelect.bind(this),
    selectOverlap: function (event) {
      return event.display === 'background';
    },
    slotLabelInterval: '01:00',
    slotDuration: this.timeInterval,
    headerToolbar: false,
    slotLabelFormat: [
      {
        hour: '2-digit',
        minute: '2-digit',
        omitZeroMinute: false,
        meridiem: false,
        hour12: false,
      },
    ],
    dayHeaderFormat: {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      omitCommas: true,
    },
    allDaySlot: false,
    slotMinTime: '06:00:00',
    slotMaxTime: '24:00:00',
    // eventMouseEnter: this.handleEventMouseEnter.bind(this),
    // eventMouseLeave: this.handleEventMouseLeave.bind(this),
  };

  sub$ = new Subject();

  dayOffs: any[] = [];

  ngOnInit(): void {
    console.log(this.userId);
    if (!this.userId) {
      const getActiveUser: any = this.store.selectSnapshot(
        AuthState.getProfile
      );
      this.userId = getActiveUser.id;
    }

    this.route.params.subscribe((route: any) => {
      console.log(route);
      if (route && route.userId) {
        this.userId = route.userId;
        this.fromRoute = true;
      }
    });

    this.getUserById();

    this.spinner.show('bookings');
    this.currentDate = format(new Date(), 'yyyy-MM-dd');

    this.store.select(AuthState.getActiveBranch).subscribe((res: any) => {
      const startTime = `0${res.whStart}`.slice(-2);
      const endTime = `0${res.whEnd}`.slice(-2);
      this.calendarOptions.slotMinTime = `${startTime}:00:00`;
      this.calendarOptions.slotMaxTime = `${endTime}:00:00`;
    });

    // beaut-365: apply the persisted day-form interval (shared across calendars).
    this.store
      .select(AppointmentState.getCalendarInterval)
      .subscribe((res: any) => {
        if (res) {
          this.timeInterval = res;
          this.calendarOptions.slotDuration = res;
        }
      });
  }

  // beaut-365: change the day-form slot granularity and persist it via the store.
  changeTimeInterval(timeInterval: string): void {
    this.store.dispatch(new CalendarTimeInterval(timeInterval));
    this.timeInterval = timeInterval;
    this.calendarOptions.slotDuration = timeInterval;
  }

  ngAfterViewInit(): void {
    this.getCalendarBooking();
  }

  getUserById() {
    this.userService.getById(this.userId).subscribe((res) => {
      this.user = res;
      this.employeeId = res?.employee?.id;
    });
  }

  getEmployeeDayOff() {
    const currentStart = format(
      new Date(this.calendarComponent.getApi().view.activeStart),
      'yyyy-MM-dd'
    );
    const currentEnd = format(
      new Date(this.calendarComponent.getApi().view.activeEnd),
      'yyyy-MM-dd'
    );
    const params = {
      employeeId: this.employeeId,
      startDate: currentStart,
      endDate: currentEnd,
    };
    this.scheduleService
      .getSchedules(this.employeeId, currentStart, currentEnd)
      .subscribe((res) => {
        const weekDays = this.mapSchedulesToEventsForAvailability(res);

        this.calendarComponent.getApi()?.addEventSource(weekDays);
      });
  }

  private mapSchedulesToEventsForAvailability(schedules: any[]): EventInput[] {
    return schedules.flatMap((schedule) => {
      const events: EventInput[] = [];

      const empId = schedule.employee?.id;
      const fullName = schedule.employee?.user?.fullName;
      const date = schedule.date;

      if (schedule.status === 'SCHEDULED') {
        const shiftStart = schedule.shiftStart;
        const shiftEnd = schedule.shiftEnd;

        // Before shift (non-working)
        if (shiftStart && shiftStart > '00:00:00') {
          events.push({
            id: `off-before-${schedule.id}`,
            resourceId: empId,
            start: `${date}T00:00:00`,
            end: `${date}T${shiftStart}`,
            display: 'background',
            title: 'Not working',
            backgroundColor: '#888888', // gray
            borderColor: '#f0f0f0',
            extendedProps: {
              type: 'off-hours',
              position: 'before',
              employeeName: fullName,
              bookingDate: date,
            },
          });
        }

        // After shift (non-working)
        if (shiftEnd && shiftEnd < '23:59:59') {
          events.push({
            id: `off-after-${schedule.id}`,
            resourceId: empId,
            start: `${date}T${shiftEnd}`,
            end: `${date}T23:59:59`,
            display: 'background',
            title: 'Not working',
            backgroundColor: '#888888',
            borderColor: '#f0f0f0',
            extendedProps: {
              type: 'off-hours',
              position: 'after',
              employeeName: fullName,
              bookingDate: date,
            },
          });
        }

        // Breaks during shift
        for (const b of schedule.breaks || []) {
          events.push({
            id: `break-${schedule.id}-${b.id}`,
            resourceId: empId,
            start: `${date}T${b.start}`,
            end: `${date}T${b.end}`,
            title: `⛔ ${b.type}`,
            display: 'background',
            backgroundColor: '#dc939a',
            borderColor: '#ff0020',
            extendedProps: {
              type: 'break',
              breakType: b.type,
              employeeName: fullName,
              bookingDate: date,
            },
          });
        }
      } else {
        // For DAY_OFF / SICK_LEAVE / VACATION
        events.push({
          id: `off-${schedule.id}`,
          resourceId: empId,
          start: `${date}T00:00:00`,
          end: `${date}T23:59:59`,
          title: schedule.status,
          display: 'background',
          backgroundColor: '#dc939a',
          borderColor: '#ff0020',
          extendedProps: {
            type: 'day-off',
            employeeName: fullName,
            status: schedule.status,
            bookingDate: date,
          },
        });
      }

      return events;
    });
  }

  nextDate() {
    const calendarApi = this.calendarComponent.getApi();
    calendarApi.next();
    this.currentDate = format(
      new Date(calendarApi.getCurrentData().currentDate),
      'yyyy-MM-dd'
    );
    this.getCalendarBooking();
  }

  prevDate() {
    const calendarApi = this.calendarComponent.getApi();
    calendarApi.prev();
    this.currentDate = format(
      new Date(calendarApi.getCurrentData().currentDate),
      'yyyy-MM-dd'
    );
    this.getCalendarBooking();
  }

  changeDate($event: any) {
    const calendarApi = this.calendarComponent.getApi();
    calendarApi.gotoDate(new Date($event));
    this.currentDate = format(new Date($event), 'yyyy-MM-dd');
    this.getCalendarBooking();
    this.calendarComponent.getApi().render();
  }

  currenDate() {
    const calendarApi = this.calendarComponent.getApi();
    calendarApi.gotoDate(new Date());
    this.currentDate = format(new Date(), 'yyyy-MM-dd 00:00:00');
    this.getCalendarBooking();
    this.calendarComponent.getApi().render();
  }

  getCalendarBooking(dayGrid = 'timeGrid') {
    this.spinner.show('bookings');
    const currentStart = format(
      new Date(this.calendarComponent.getApi().view.activeStart),
      'yyyy-MM-dd'
    );
    const currentEnd = format(
      new Date(this.calendarComponent.getApi().view.activeEnd),
      'yyyy-MM-dd'
    );

    const params = {
      userId: this.userId,
      date: this.currentDate,
      dateRange: [currentStart, currentEnd],
    };

    this.bookingService
      .getCalendarEmployeeBookingNew(params)
      .subscribe((res: any[]) => {
        const mapBooking = res.map((m: any) => {
          // beaut-324: sum per-procedure lastPrice instead of the drifted
          // booking-level price (same helper the main calendar uses).
          const { price: calcPrice, salePrice: calcSalePrice } =
            computeCalendarBookingAmounts(m);
          return {
            groupId: m.visit?.id,
            employeeName: m.employee.user.fullName,
            user: m.user,
            cash: m.cash,
            card: m.card,
            salePercent: m.salePercent,
            price: calcPrice ? +Number(calcPrice).toFixed(2) : 0,
            salePrice: calcSalePrice ? +Number(calcSalePrice).toFixed(2) : 0,
            description: m.description,
            createdBy: m.createdBy?.fullName,
            completedBy: m.completedBy?.fullName,
            createdAt: m.createdAt,
            bookingStartTime: m.startTime,
            bookingEndTime: m.endTime,
            id: m.id,
            resourceId: m.employeeId,
            start: transformDateTime(m.bookingDate, m.startTime),
            end: transformDateTime(m.bookingDate, m.endTime),
            title: `${m.user?.fullName} ${m.user?.mobilePhone}`,
            backgroundColor:
              m.service?.serviceCategory?.color ||
              m.bookingServices?.[0]?.service?.serviceCategory?.color ||
              null,
            icon: m.status === 2 ? 'lock' : false,
            displayEventTime: true,
            status: m.status,
            visitStatus: m.visit?.status || null,
            onUserRequest: m.onUserRequest,
            bookingDate: m.bookingDate,
            services: m.services.map((s: any) => s.name)?.join(', '),
            fullName: m.user?.fullName,
            mobilePhone: m.user?.mobilePhone,
          };
        });
        console.log(mapBooking);
        const calendarApi = this.calendarComponent.getApi();
        this.calendarOptions.events = mapBooking;
        this.calendarOptions.eventDidMount = (mountArg: any) => {
          if (mountArg.event.extendedProps['icon']) {
            mountArg.el
              .querySelector('.fc-event-time')
              ?.classList.add('fas', 'fa-lock');
          }
        };
        this.getEmployeeDayOff();
        setTimeout(() => calendarApi.render(), 0);

        this.spinner.hide('bookings');
      });
  }

  handleEventClick(clickInfo: EventClickArg) {
    console.log(clickInfo);
    console.log(clickInfo.event.display === 'background');
    const oldStyle = clickInfo.event.extendedProps['oldStyle'];
    if (clickInfo.event.display === 'background') return;
    const groupId = clickInfo.event.groupId;
    const getEventsByGroupId = this.calendarComponent
      .getApi()
      .getEvents()
      .filter((event) => event.groupId === groupId);
    console.log(getEventsByGroupId);
    if (clickInfo.event.extendedProps['disabled']) return;

    const modal = this.drawerService.create({
      nzClosable: true,
      nzMaskClosable: false,
      nzTitle: this.translateService.instant('calendar.planVisit'),
      nzContent: VisitManageComponent,
      nzWidth: '1024px',
      nzBodyStyle: { padding: '0' },
      nzData: {
        visitId: groupId,
      },
    });
    modal.afterClose.pipe(takeUntil(this.sub$)).subscribe((res) => {
      this.store.dispatch(new ClearAddEmployeeAppointment());
      const calendarApi = this.calendarComponent.getApi();
      this.currentDate = format(
        new Date(calendarApi.getCurrentData().currentDate),
        'yyyy-MM-dd'
      );
      this.getCalendarBooking();
      setTimeout(() => this.calendarComponent.getApi().render(), 0);
    });
  }

  handleDateClick(clickInfo: any) {
    console.log(clickInfo);
    // if (!clickInfo.resource) return;

    // const resourceId = clickInfo.resource.id;

    const startStr = clickInfo.dateStr;

    const modal = this.drawerService.create({
      nzClosable: true,
      nzMaskClosable: false,
      nzTitle: this.translateService.instant('calendar.planVisit'),
      nzContent: VisitManageComponent,
      nzWidth: '1024px',
      nzBodyStyle: { padding: '0' },
      nzData: {
        employeeId: this.employeeId,
        date: startStr,
      },
    });

    modal.afterClose.pipe(takeUntil(this.sub$)).subscribe((res) => {
      this.store.dispatch(new ClearAddEmployeeAppointment());
      const calendarApi = this.calendarComponent.getApi();
      this.currentDate = format(
        new Date(calendarApi.getCurrentData().currentDate),
        'yyyy-MM-dd'
      );
      this.getCalendarBooking();
      setTimeout(() => this.calendarComponent.getApi().render(), 0);
    });
  }

  handleDateSelect(clickInfo: any) {
    // console.log(clickInfo);
    // // if (!clickInfo.resource) return;
    //
    // // const resourceId = clickInfo.resource.id;
    //
    // const startStr = clickInfo.dateStr;
    //
    //
    // const modal = this.drawerService.create({
    //   nzClosable: true,
    //   nzMaskClosable: false,
    //   nzTitle: this.translateService.instant('calendar.planVisit'),
    //   nzContent: VisitManageComponent,
    //   nzWidth: '1024px',
    //   nzBodyStyle: { padding: '0' },
    //   nzData: {
    //     employeeId: this.employeeId,
    //     date: startStr
    //   }
    // });
    //
    // modal.afterClose.pipe(takeUntil(this.sub$)).subscribe((res) => {
    //   this.store.dispatch(new ClearAddEmployeeAppointment());
    //   const calendarApi = this.calendarComponent.getApi();
    //   this.currentDate = format(new Date(calendarApi.getCurrentData().currentDate), 'yyyy-MM-dd');
    //   this.getCalendarBooking();
    //   setTimeout(() => this.calendarComponent.getApi().render(), 0);
    // });
  }

  dayGridChange(dayGrid: string) {
    // console.log(dayGrid);
    let date: any = format(new Date(), 'yyyy-MM-dd');
    if (dayGrid === 'timeGridWeek') {
      date = {
        start: format(new Date(), 'yyyy-MM-dd'),
        end: format(new Date(addDays(new Date(), 7)), 'yyyy-MM-dd'),
      };
    }
    this.calendarComponent.getApi().changeView(dayGrid, date);
    this.currenDate();
  }

  back() {
    this._location.back();
  }
}
